/* eslint-disable react/display-name */
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

import InfoStepper from '_components/atomic/InfoStepper';

const { colors, devices, fontSizes, spaces } = theme;

const StyledProcessSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${spaces.large24X * 10 + 80}px;
  padding-top: ${spaces.large15X}px;
  position: relative;

  @media ${devices.tablet} {
    padding-top: ${spaces.large}px;
  }
`;

const StyledTitle = styled.div`
  margin-bottom: ${spaces.large11X}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.large11X}px;
  line-height: 130%;
  color: ${colors.gray[800]};

  @media ${devices.tablet} {
    margin-bottom: ${spaces.large}px;
    font-size: ${fontSizes.large2X}px;
    text-align: center;
  }
`;

const StyledBody = styled.div``;

const StyledBackground = styled(
  forwardRef(
    (
      { height, width, radius, rotate, top, bottom, left, right, ...props },
      ref
    ) => <div ref={ref} {...props} />
  )
)`
  position: absolute;

  background: linear-gradient(
    180deg,
    #e4f1fd 0%,
    #e0eaff 0.01%,
    rgba(255, 255, 255, 0) 100%
  );

  opacity: 0.5;
  z-index: -1;

  ${({ radius }) =>
    radius &&
    css`
      border-top-left-radius: ${radius}px;
      border-top-right-radius: ${radius}px;
    `}

  ${({ top }) =>
    typeof top !== 'undefined' &&
    css`
      top: ${typeof top === 'string' ? top : `${top}px`};
    `}

  ${({ bottom }) =>
    typeof bottom !== 'undefined' &&
    css`
      bottom: ${typeof bottom === 'string' ? bottom : `${bottom}px`};
    `}

  ${({ left }) =>
    typeof left !== 'undefined' &&
    css`
      left: ${typeof left === 'string' ? left : `${left}px`};
    `}

  ${({ right }) =>
    typeof right !== 'undefined' &&
    css`
      right: ${typeof right === 'string' ? right : `${right}px`};
    `}

  ${({ rotate }) =>
    rotate &&
    css`
      transform: ${`rotate(${rotate}deg)`};
    `}

  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
    `}

  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `}

  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }
`;

const ProcessSection = ({ title, activeStepIdx, steps = [] }) => (
  <StyledProcessSection>
    <StyledTitle>{title}</StyledTitle>
    <StyledBody>
      <InfoStepper activeStepIdx={activeStepIdx} steps={steps} />
    </StyledBody>
    <StyledBackground
      height={1546}
      width={508}
      radius={400}
      left={`calc(50% - ${508 / 2}px)`}
      top={0}
    />
  </StyledProcessSection>
);

ProcessSection.propTypes = {
  title: PropTypes.node,
  activeStepIdx: PropTypes.number,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      subtitle: PropTypes.node,
      description: PropTypes.node,
      imageSrc: PropTypes.string,
      imageAlt: PropTypes.string,
    })
  ),
};

export default ProcessSection;
